<template>
  <section class="points-exchange-redeem-page mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Resgate seus pontos"></app-page-header>

    <div class="row mb-4">
      <div class="col-md-8 col-sm-12 offset-md-2">
        <b-notification v-if="isLoading && client.has_card" type="is-danger">
          Verificamos que você ainda não possui um cartão ativo. Seu resgate
          será registrado e seus pontos creditados assim que você receber e
          ativar seu cartão.
        </b-notification>
      </div>
    </div>

    <div class="container box points-box">
      <div class="row">
        <div class="address col-md-3 col-sm-12" v-show="!isLoading">
          <strong>Endereço</strong>
          <p>{{ client.address.street }}, {{ client.address.number }}</p>
          <p>{{ client.address.neighborhood }}</p>
          <p>
            {{ client.address.city.name }} -
            {{ client.address.city.state.code }}
          </p>

          <router-link :to="{ name: 'site.my-info' }">Editar</router-link>
        </div>

        <div class="image col-md-4 col-sm-12">
          <img src="@/assets/img/cards.png" alt="Cartões Mapi" />
        </div>

        <div class="redeem-points col-md-5 col-sm-12">
          <div class="section">
            <h2>TOTAL DE PONTOS</h2>
            <div class="points-container">
              <span class="points">{{ points }}</span>
              <span class="conversion"
                >Conversão: R$ {{ conversion | number }}</span
              >
            </div>
          </div>
          <hr />

          <div class="section">
            <div v-show="points > 0">
              <h2>DISPONÍVEL PARA RESGATE</h2>
              <div class="points-container">
                <span class="points">{{ points }}</span>
                <span class="conversion"
                  >Conversão: R$ {{ conversion | number }}</span
                >
              </div>
            </div>
            <span class="message" v-show="points == 0"
              >Você ainda não tem saldo suficiente.</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="redeem-container" v-show="points > 0">
      <h1>Quantos pontos deseja resgatar?</h1>

      <div class="redeem-inputs">
        <app-input class="points-input" type="number" v-model="redeemPoints" />
        <button 
          @click="onSubmit()"
          :disabled="redeemPoints <= 0 || isLoading"
          type="button"
          class="app-button"
        >
          RESGATAR
        </button>
      </div>
      <p>
        Ao clicar no botão de resgate acima, estou de acordo com o
        <br />
        <a
          href="https://www.clubevendaeganhe.com.br/files/termos/termo_quitacao.pdf"
          >Termo de Adesão à Campanha e Uso do Cartão MAPIPrêmio.</a
        >
      </p>
    </div>

    <div class="container box info-box" Style="display:none">
      <div class="info-important">
        <h2>ATENÇÃO</h2>
        <p>
          O prazo de conversão de pontos em saldo no cartão é de até 48h úteis.
          A conversão dos pontos em saldo no cartão não é automática e você
          precisa realizar a CONFIRMAÇÃO DE RECEBIMENTO DO CARTÃO para a Central
          de Atendimento pelo e-mail:
          <a href="mailto:atendimento@clubevendaeganhe.com.br"
            >atendimento@clubevendaeganhe.com.br</a
          >, telefone: (41) 3114-7282 ou WhatsApp: (41) 99267-8525. Sem essa
          confirmação, o valor ficará bloqueado por motivos de segurança.
        </p>
      </div>

      <h2>PRIMEIRO ACESSO AO CARTÃO</h2>
      <p>
        A partir do momento que você estiver com seu cartão em mãos, acesse o
        menu
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://cliente.acessocard.com.br/MAPICOM"
          >ACESSE SEU CARTÃO</a
        >, selecione primeiro acesso e efetue seu cadastro junto à operadora
        para poder utilizá-lo.
      </p>

      <h2>TAXAS DE ENVIO DO CARTÃO</h2>
      <p>
        Taxa de envio da 1ª via do cartão: R$0,00.
        <br />Solicitação de 2ª via do cartão: R$15,00 descontado do saldo do
        cartão.
      </p>

      <h2>PRAZO DE ENVIO</h2>
      <p>
        O prazo de envio é de 15 dias úteis a partir da confirmação de sua
        solicitação e o cartão será entregue no endereços de cadastro. Em caso
        de não recebimento de seu cartão, após esse período, entre em contato
        com a Central de Atendimento pelo e-mail:
        <a href="mailto:atendimento@clubevendaeganhe.com.br"
          >atendimento@clubevendaeganhe.com.br</a
        >
      </p>

      <h2>PRAZO DE TRANSFERÊNCIA DE PONTOS</h2>
      <p>
        O prazo de conversão de pontos em saldo no cartão é de até 48h úteis. A
        conversão dos pontos em saldo no cartão não é automática.
      </p>

      <h2>TAXAS DE SAQUE, TRANSFERÊNCIA E MANUTENÇÃO</h2>
      <p>
        Saque: R$9,00 Transferência para conta: R$6,50 (Operação disponível
        apenas para conta do mesmo titular do cartão) Manutenção do cartão:
        R$3,90 mensal sobre o saldo do cartão.
      </p>
    </div>
  </section>
</template>

<script>
import RedemptionService from '@/services/redemption.service';
import ExchangeService from '@/services/exchange.service';
import ClientService from '@/services/client.service';

import { UPDATE_USER } from '@/store/actions/auth';
import { SUM_POINTS } from '@/store/actions/auth';

export default {
  name: 'points-exchange-redeem-page',
  data: () => {
    return {
      isLoading: false,
      isSubmitting: false,
      exchange: null,
      client: {
        points: null,
        address: {
          street: null,
          number: null,
          neighborhood: null,
          city_id: null, 
          city: {
            name: null,
            state: {
              code: null,
            },
          },
        },
      },
      redeemPoints: null,
    };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    conversion() {
      return this.exchange ? this.exchange.value * this.points : 0;
    },
  },
  methods: {
    load() {
      this.isLoading = true;

      Promise.all([ClientService.getSelf(), ExchangeService.get()])
        .then(([{ data: client }, { data: exchange }]) => {
          this.exchange = exchange;
          this.client = client;
          this.redeemPoints = client.points;
          this.$store.dispatch(UPDATE_USER, { points: client.points });
        })
        .finally(() => setTimeout(() => (this.isLoading = false), 200));
    },
    onSubmit() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      this.isLoading = true;

      this.$buefy.dialog.confirm({
        message: this.redeemPoints < 0 ? 'Tem certeza que deseja realizar o resgate ? <br><br> <b>Resgates menores que 50 pontos tem cobrança de taxa 1 ponto </b> <br> Ao clicar no botão <b>SIM</b>, estou de acordo com o <b>Termo de Adesão à Campanha</b> e as <b>Taxas</b> cobradas pela operação' : 'Tem certeza que deseja realizar o resgate ?',
        cancelText: 'Cancelar',
        confirmText: 'Sim', 
        type: 'is-primary',
        onConfirm: () => this.submit(), 
        onCancel: () => {
          this.isSubmitting = false;
          this.isLoading = false;
        },
      });
    },
    submit() {
      const points = this.redeemPoints;

      this.process(points).finally(() => {
        this.isSubmitting = false;
        this.isLoading = false;
      });
    },
    process(points, noCard = false) {
      return RedemptionService.tradeCard(points, noCard)
        .then(() => {
          this.$store.dispatch(SUM_POINTS, -points);
          this.toastify('Resgate concluído com sucesso!');
          this.$router.push('/');
        })
        .catch(({ response }) => {
          const { status, data } = response;

          if (status === 403 && data.activateCard) {
            this.showCardDialog(points);
          } else if (status === 429) {
            this.toastify(
              'Verificamos múltiplas tentativas consecutivas de resgate. Tente novamente mais tarde.',
              'error'
            );
          } else {
            this.toastify(data.message, 'error');
          }
        });
    },
    showCardDialog(points) {
      this.$buefy.dialog.prompt({
        title: 'Ativar cartão',
        message:
          'Verificamos que o seu cartão ainda não foi ativado. Insira abaixo os 4 últimos digitos dele para ativá-lo.',
        cancelText: 'Não recebi o cartão',
        confirmText: 'Ativar',
        inputAttrs: {
          placeholder: 'ex: 1234',
          minLength: 4,
          maxLength: 4,
        },
        onCancel: () => {
          this.isLoading = true;

          this.process(points, true)
            .then(() => {
              this.$buefy.dialog.alert({
                title: 'Resgate realizado',
                message:
                  'A carga só será efetivada após a ativação do seu cartão! Ative-o assim que recêbe-lo.',
              });
            })
            .finally(() => (this.isLoading = false));
        },
        onConfirm: (value) => this.activateCard(value),
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
section.points-exchange-redeem-page {
  position: relative;
}

.box {
  background: var(--color-light-grey);
  border-radius: 12px;
  padding: 2em;

  font-size: 1.1em;

  strong {
    font-weight: bold;
    font-size: 1.2em;
    color: var(--text-color-medium);
    margin-bottom: 0.8em;
  }

  .address {
    display: flex;
    flex-direction: column;
  }

  .redeem-points {
    h2 {
      font-weight: bold;
      font-size: 1.2em;
      color: var(--text-color-medium);
    }

    .section {
      margin: 0;

      .points-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .points {
          font-size: 2em;
          font-weight: bold;
          color: var(--color-primary);
        }

        .conversion {
          font-size: 1em;
          color: var(--text-color-light);
        }
      }

      .message {
        color: var(--color-primary);
        background: var(--color-light-grey);
        font-weight: bold;
        font-size: 1.3em;
      }
    }

    hr {
      margin: 0;
      padding: 0;
      background: var(--text-color-light);
    }
  }
}

h1 {
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  margin-top: 1.8em;
}

.redeem-container {
  .redeem-inputs {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 15vw;
    margin: 2em auto;
  }

  p {
    text-align: center;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.info-box {
  margin-top: 2em;
  h2 {
    font-weight: bold;

    &:not(:first-child) {
      margin-top: 2em;
    }
  }

  .info-important {
    background: var(--color-secondary);
    padding: 1em;
    border-radius: 8px;
    color: white;

    a {
      color: #fff;
      font-weight: bold;

      &:hover {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 992px) {
  section.points-exchange-redeem-page {
    padding: 0 1em;

    .redeem-container {
      .redeem-inputs {
        max-width: 100%;
      }
    }
  }

  .info-box {
    padding: 1em;
  }
}
</style>
